import { render, staticRenderFns } from "./wxxiangqingCreate.vue?vue&type=template&id=7f2b09db&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./wxxiangqingCreate.vue?vue&type=script&lang=js"
export * from "./wxxiangqingCreate.vue?vue&type=script&lang=js"
import style0 from "./wxxiangqingCreate.vue?vue&type=style&index=0&id=7f2b09db&prod&scoped=true&lang=css"
import style1 from "./wxxiangqingCreate.vue?vue&type=style&index=1&id=7f2b09db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2b09db",
  null
  
)

export default component.exports